module.exports = __webpack_public_path__ + "static/media/nail-tech.95c45431.png";